import React from "react";
import { clsx } from "clsx";
import { RxInstagramLogo, RxTwitterLogo } from "react-icons/rx";
import { FiRss } from "react-icons/fi";
import { TbMail } from "react-icons/tb";

interface ISNSProps extends React.PropsWithChildren {}

export default function SNS({ children }: ISNSProps) {
  return (
    <div className={clsx("flex", "space-x-4", "text-3xl")}>
      <a href="https://twitter.com/wienpedia">
        <RxTwitterLogo />
      </a>
      <a href="https://www.instagram.com/wienpedia">
        <RxInstagramLogo />
      </a>
      <a href="/rss.xml">
        <FiRss />
      </a>
      <a href="mailto:wienpedia">
        <TbMail />
      </a>
    </div>
  );
}
